import { apiClient } from "@/api/api-client";

export const userSessionsService = {
	terminateSession: async (sessionId: number): Promise<{ message: string }> => {
		const response = await apiClient.delete(`/profile/sessions/${sessionId}`);
		return response.data;
	},

	terminateOtherSessions: async (): Promise<{ message: string }> => {
		const response = await apiClient.post("/profile/sessions/terminate-others");
		return response.data;
	},
};
